<template>
    <div
        @click="emits('click')"
        class="text-blue-500 hover:text-blue-700 transition-all duration-300 py-8 flex items-center gap-2 cursor-pointer"
    >
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
        >
            <path
                fill="currentColor"
                d="m7.825 13l5.6 5.6L12 20l-8-8l8-8l1.425 1.4l-5.6 5.6H20v2z"
            ></path>
        </svg>
        Back
    </div>
</template>
<script setup>
const emits = defineEmits(["click"]);
</script>
